import { Injectable } from '@angular/core';
import { Profile, Unit } from '@app/models/profile.model';
import { AuthService } from '@app/services/auth.service';
import { Action, State, StateContext } from '@ngxs/store';
import { tap } from 'rxjs';
import { NameLocalStorage } from '@app/models/record.model';
import { WebviewService } from '@app/services/webview.service';
import { ClearAuth, Login, Logout, RefreshToken, SelectUnit, SetToken } from './auth.classes';
import { RemoveDataSet } from '../data/data.classes';
import { ClearSetting } from '../setting/setting.classes';
import { ResetScheduleFilter } from '../schedule/schedule.classes';

export interface AuthStateModel {
  accessToken: string | null;
  refreshToken: string | null;
  profile: Profile | null;
}

@State<AuthStateModel>({
  name: 'auth',
  defaults: {
    accessToken: null,
    refreshToken: null,
    profile: null,
  },
})
@Injectable()
export class AuthState {
  constructor(private authService: AuthService, private webviewService: WebviewService) { }

  @Action(SetToken)
  setToken(ctx: StateContext<AuthStateModel>, auth: SetToken) {
    const { accessToken, refreshToken } = auth;
    if (accessToken !== '' && refreshToken !== '') {
      ctx.patchState(
        {
          accessToken,
          refreshToken
        }
      );
    }

  }

  @Action(Login)
  login(ctx: StateContext<AuthStateModel>, action: Login) {
    // localStorage.removeItem(NameLocalStorage.DISPLAY_SETTING_DATE);
    // localStorage.removeItem(NameLocalStorage.CONDITION_FILTER);
    // return this.authService.login(action.payload)
    //   // .pipe(
    //   //  tap(({ accessToken, refreshToken, ...profile }) => {
    //   .subscribe(({ accessToken, refreshToken, ...profile }) => {
    //     this.authService.checkStaffCode(accessToken).subscribe((res) => {
    //       if (res) {
    //         const { staffCode, fullName, staffFirstName, staffLastName, unitList } =
    //           profile;
    //         const selectedUnit =
    //           unitList && unitList.length === 1 ? unitList[0] : null;
    //         ctx.patchState({
    //           accessToken: accessToken ?? null,
    //           refreshToken: refreshToken ?? null,
    //           profile: {
    //             staffCode,
    //             fullName,
    //             staffFirstName,
    //             staffLastName,
    //             unitList: sortUnitList(unitList),
    //             selectedUnit,
    //           },
    //         });
    //       } else {
    //         this.logout(ctx);
    //       }
    //     })
    //   });
    localStorage.removeItem(NameLocalStorage.DISPLAY_SETTING_DATE);
    localStorage.removeItem(NameLocalStorage.CONDITION_FILTER);
    return this.authService.login(action.payload)
      // .pipe(
      //  tap(({ accessToken, refreshToken, ...profile }) => {
      .subscribe(({ accessToken, refreshToken, ...profile }) => {
        const { staffCode, fullName, staffFirstName, staffLastName, unitList } =
          profile;
        const selectedUnit = unitList && unitList.length === 1 ? unitList[0] : null;
        ctx.patchState({
          accessToken: accessToken ?? null,
          refreshToken: refreshToken ?? null,
          profile: {
            staffCode,
            fullName,
            staffFirstName,
            staffLastName,
            unitList: sortUnitList(unitList),
            selectedUnit,
          },
        });
      });
  }

  @Action(RefreshToken)
  refreshToken(ctx: StateContext<AuthStateModel>) {
    const { accessToken, refreshToken } = ctx.getState();
    ctx.patchState({ accessToken: null, refreshToken: null });
    return this.authService
      .refresh(accessToken, refreshToken)
      .pipe(tap((result) => ctx.patchState(result)));
  }

  @Action(Logout)
  logout(ctx: StateContext<AuthStateModel>) {
    const { accessToken } = ctx.getState();
    localStorage.clear();
    ctx.setState({
      accessToken: null,
      refreshToken: null,
      profile: null,
    });
    return ctx
      .dispatch([
        new ClearSetting(),
        new ResetScheduleFilter,
        new RemoveDataSet()
      ])
      .pipe(tap(() => { this.authService.deleteToken(accessToken); this.webviewService.kidsLogoutSignal() }));
  }

  @Action(ClearAuth)
  clearAuth(ctx: StateContext<AuthStateModel>) {
    ctx.setState({
      accessToken: null,
      refreshToken: null,
      profile: null,
    });
  }

  @Action(SelectUnit)
  selectUnit(ctx: StateContext<AuthStateModel>, action: SelectUnit) {
    const { profile } = ctx.getState();
    ctx.patchState({
      profile: {
        ...(profile as Profile),
        selectedUnit: action.unit,
      },
    });
  }
}

const sortUnitList = (unitList: Unit[]) => {
  return unitList.sort((a, b) => {
    if (a.companyId < b.companyId) {
      return -1;
    } else if (a.companyId > b.companyId) {
      return 1;
    } else if (a.blockId < b.blockId) {
      return -1;
    } else if (a.blockId > b.blockId) {
      return 1;
    } else if (a.id < b.id) {
      return -1;
    } else {
      return 1;
    }
  });
};
